import _findIndex from 'lodash/findIndex';
import _isString from 'lodash/isString';
import { ALIGNMENT_TO_CLASS_MAP, DEFAULT_CONTAINER_CLASS, DEFAULT_ALIGNMENT_CLASS } from './PatternedImageRow.constants';
export function getImageId(image) {
  if (_isString(image)) {
    return image;
  }
  var _id = image._id;
  return _id;
}
export function getContainerClassName(pattern) {
  var alignment = pattern.alignment;
  var flexAlignmentClass = ALIGNMENT_TO_CLASS_MAP[alignment] || DEFAULT_ALIGNMENT_CLASS;
  return [DEFAULT_CONTAINER_CLASS, flexAlignmentClass].join(' ');
}
export function getContainerStyle(pattern) {
  var width = pattern.width,
    height = pattern.height;
  return {
    flex: width / 100,
    height: "".concat(height, "%")
  };
}
export function getImagePattern(image, images, patterns) {
  var imageId = getImageId(image);
  if (!imageId) {
    return patterns[0];
  }
  var imageIndex = _findIndex(images, function (aImage) {
    return getImageId(aImage) === imageId;
  });
  if (imageIndex < 0) {
    return patterns[0];
  }
  return patterns[imageIndex % patterns.length];
}